// extracted by mini-css-extract-plugin
module.exports = {"BuildControls":"BuildControls_BuildControls__3lcTZ","OrderButton":"BuildControls_OrderButton__1YSUv","enable":"BuildControls_enable__BhMpz"};